import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Drawer, Box, Group, Text, Textarea, ActionIcon, Flex } from '@mantine/core';
import { useResizeObserver, useViewportSize } from '@mantine/hooks';
import { IconCaretRight, IconMessageChatbot, IconReload, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../../context/loginContext";
import { BE_API_ONE, utils, tabProject } from "../../../utils/globalVariables";
import { sqlDateToHumanDate, safetyDecodeJWT, stringDivider, safeValue } from "../../../utils/globalFunctions";

import ModalResponse from "../../../components/general/ModalResponse";
import LoaderLine from "../../../components/general/LoaderLine";

const FeedbackDrawer = ({
  stateShow,
  fnShow,
  stateData,
  fnShouldUpdateIndex
}) => {

  const { tab, URI1 } = useParams();
  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'FeedbackDrawer-1',
    successSubmitData: 'FeedbackDrawer-2',
    errorSubmitData: 'FeedbackDrawer-3',
  })

  const [refTop, rectTop] = useResizeObserver();
  const [refBottom, rectBottom] = useResizeObserver();
  const { height } = useViewportSize();

  const [data, setData] = React.useState({
    bodyHeight: 0,

    data: [],
    dataFlag: 'idle',
    dataInitLoading: false,
    dataRefresh: new Date(),

    projectId: '',
    customerName: '',
    barangNama: '',
    message: '',
    submitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (stateShow) {
      setTimeout(() => {
        setData(d => ({ ...d, bodyHeight: height - rectBottom.height - rectTop.height }));
      }, 300);
    }
  }, [stateShow, rectTop, rectBottom, height])

  React.useEffect(() => {
    if (stateShow) {
      setData(d => ({ ...d, dataInitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('id', stateData.data ? ((tab && (tab === tabProject.nota) && URI1) ? URI1 : stateData.data.project_id) : URI1);
      formDT.append('is_customer_id', (tab && (tab === tabProject.nota) && URI1) ? 1 : 0);
      formDT.append('project_process_nota', utils.projectProcess.nota.value);
      formDT.append('project_is_cancel', '');

      axios({
        method: 'post',
        url: BE_API_ONE + '/get_feedback',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: response.data.data.length > 0 ? true : false,

            projectId: stateData.data ? stateData.data.project_id : (Array.isArray(response.data.data_project) && (response.data.data_project.length > 0) ? response.data.data_project[0]['project_id'] : ''),
            customerName: stateData.data ? stateData.data.customer_name : (Array.isArray(response.data.data_project) && (response.data.data_project.length > 0) ? response.data.data_project[0]['customer_name'] : ''),
            barangNama: stateData.data ? stateData.data.barang_nama : (Array.isArray(response.data.data_project) && (response.data.data_project.length > 0) ? response.data.data_project[0]['barang_nama'] : ''),
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        // if (response.data.flag_status === 'no-data') {
        //     setData(d => ({
        //         ...d,
        //         projectDataFlag: false
        //     }));
        // }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, stateData.data, stateShow, data.dataRefresh, tab, URI1])

  const submitData = () => {
    setData(d => ({ ...d, submitLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('message', data.message);
    formDT.append('project_id', data.projectId);

    axios({
      method: 'post',
      url: BE_API_ONE + '/add_feedback',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false }));

      if (response.data.flag_status === 'isset') {
        // fnShouldUpdateIndex(tab === tabHomePengecekanIndex);
        fnShouldUpdateIndex(true);

        setData(d => ({
          ...d,
          message: '',
          data: response.data.data
        }))
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan. Muat ulang halaman untuk mendapatkan data terbaru.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false }));

      notifications.show({
        id: notificationId.current.errorSubmitData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: false,
      })
    })
  }

  return (
    <React.Fragment>
      <Drawer
        opened={stateShow}
        onClose={() => fnShow(false)}
        withCloseButton={false}
        position="right"
        styles={{
          content: { overflowY: 'hidden !important' },
          body: { padding: 0 }
        }}
      >
        <Box
          ref={refTop}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
          }}
        >
          {data.dataInitLoading &&
            <LoaderLine
              statePosition='absolute'
              stateIsTop={false}
            />
          }

          <Group noWrap position="apart" p='sm'>
            <Group noWrap>
              <ActionIcon
                size='lg'
                variant="light"
                radius='xl'
                color="blue"
                onClick={() => fnShow(false)}
              >
                <IconArrowLeft size='1.25rem' stroke={1.5} />
              </ActionIcon>

              <Box>
                <Text tt='uppercase' fw={500} lineClamp={1}>{data.customerName}</Text>
                <Text size='sm' lineClamp={1}>
                  {stringDivider(data.projectId, [4, 6, 8], '.', ' - ')} - {safeValue(data.barangNama, '[Nama Barang]')}
                </Text>
              </Box>
            </Group>

            <ActionIcon
              size='lg'
              variant="light"
              color="green"
              radius='xl'
              title="Refresh"
              onClick={() => setData(d => ({ ...d, dataRefresh: new Date() }))}
            >
              <IconReload size={18} stroke={1.5} />
            </ActionIcon>
          </Group>
        </Box>

        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          // wrap="wrap"

          mt={rectTop.height}
          p='sm'
          sx={(tema) => ({
            overflowY: 'auto',
            height: `${data.bodyHeight}px !important`,
            maxHeight: `${data.bodyHeight}px !important`,

            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px',
            },

            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent'
            },

            '&::-webkit-scrollbar-thumb': {
              backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
              borderRadius: '4px'
            },

            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[5] : tema.colors.dark[3],
            },
          })}
        >
          {Array.isArray(data.data) && (data.data.length > 0) ? Object.keys(data.data).map((key, index) => {
            return (
              <Box
                key={key}

                p='.5rem'
                mb='.5rem'
                sx={(tema) => ({
                  borderRadius: tema.radius.md,
                  backgroundColor: tema.colorScheme === 'light' ? (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappi') === data.data[key].user_id ? tema.fn.rgba(tema.colors.green[6], 0.2) : tema.colors.gray[2]) : (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappi') === data.data[key].user_id ? tema.fn.rgba(tema.colors.green[5], 0.15) : tema.colors.dark[5]),
                  width: '90%',
                  alignSelf: safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappi') === data.data[key].user_id ? 'flex-end' : 'flex-start'
                })}
              >
                <Text size='xs' color="dimmed">
                  {data.data[key].user_name_created}
                </Text>

                <Text
                  size='sm'
                  sx={{ wordBreak: 'break-word' }}
                >
                  {data.data[key].message}
                </Text>

                <Text size='xs' color="dimmed" ta='right'>
                  {sqlDateToHumanDate({
                    stateDate: data.data[key].date_created,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: true,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day',
                    stateWithSecond: false
                  })}
                </Text>
              </Box>
            )
          })
            :
            <Flex
              justify="center"
              align="center"
              direction="column"
              // wrap="wrap"

              sx={{
                width: '100%',
                height: '100%'
              }}
            >
              <Text ta='center'>Belum ada feedback</Text>

              <IconMessageChatbot
                size={48}
                strokeWidth={1}
              />
            </Flex>
          }
        </Flex>

        <Box
          ref={refBottom}
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
          }}
        >
          <Group
            noWrap
            position="apart"
            p='sm'
          >
            <Textarea
              autosize
              variant="default"
              minRows={1}
              maxRows={2}
              radius='md'
              sx={(tema) => ({
                width: '100%',
              })}

              styles={(tema) => ({
                input: {
                  backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[6]
                }
              })}

              placeholder="Tulis feedback disini.."
              value={data.message}
              onChange={(val) => setData(d => ({ ...d, message: val.target.value }))}
            />

            <ActionIcon
              size='lg'
              variant="filled"
              radius='xl'
              color="green"
              onClick={submitData}

              disabled={!data.message}
              loading={data.submitLoading}
            >
              <IconCaretRight size='1.4rem' stroke={1.25} />
            </ActionIcon>
          </Group>
        </Box>
      </Drawer>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default FeedbackDrawer;